export enum ColumnType {
  name = "name",
  address = "address",
  lastVisit = "lastVisit",
  wcpid = "wcpid",
  isPaid = "isPaid",
}

export const columnLabels = Object.values(ColumnType);
